<mapfre-card 
    [singleCard]="false"
    [additionalClasses]="'policy-details'"> 
    <div class="single-card-column policy-card">
        <div class="row text-center">
      <div class="col">
            <div class="header-icon full-icon">
              <svg-policy-error-svg></svg-policy-error-svg>
            </div>
            <h1 class="title-copy">{{ 'POLICYBELONGS_TO_ANOTHER' | translate }}</h1> 
          </div>
        </div>  
        <app-policy-belong-to-another-screen></app-policy-belong-to-another-screen>
  <div class="row text-center">
    <div class="col">
      <mapfre-button
        [additionalClasses]="'ghost secondary small'"
        [routerLink]="['/my-insurance', 'link-policy']"
      >{{ 'CANCEL' | translate }}</mapfre-button>
    </div>
  </div>
  </div>
  </mapfre-card>
  